export class SquareMoney {
  amount: number;
  currency: string;
  constructor() {}
}
